import React from 'react';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { useIsEmbeddedMobile } from '../../../_hooks/useIsEmbeddedMobile';

interface Props {
  data: {
    label: string;
    value: string;
    isHighlighted: boolean;
  }[];
}

export const LabeledList = ({ data }: Props) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  return (
    <Box flex={1}>
      {data.map(({ label, value, isHighlighted }) => (
        <Box
          key={label}
          display="flex"
          justifyContent="space-between"
          mb={isEmbeddedMobile ? '32' : '16'}
        >
          <Text
            fontWeight={isHighlighted ? 600 : isEmbeddedMobile ? 500 : 400}
            pl={isHighlighted ? 0 : 10}
            mr="16"
          >
            {label}
          </Text>

          <Text
            variant="tabular"
            textAlign="right"
            fontWeight={isHighlighted ? 600 : isEmbeddedMobile ? 500 : 400}
          >
            {value}
          </Text>
        </Box>
      ))}
    </Box>
  );
};
